export default {
      id: "depth-1-usage",
      viewBox: "0 0 28 15",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#depth-1",
      toString: function () {
        return this.url;
      }
    }